<template>
    <section class="black-bg">
        <b-container>
            <b-row class="width70">
                <b-col>
                    <div class="d-flex justify-content-around">
                        <div>
                            <Skeleton class="whiteboxwidth" height="2.5rem" v-if="loading" />
                            <WhiteBox v-else :boxtext="leftboxtext.fromstr" :StoreId="leftboxtext.fromstoreid"
                                :storestatus="leftboxtext.fromstatus"
                                :Badge="leftboxtext.fromcount !== '' ? true : false" :count="leftboxtext.fromcount"
                                class="whiteboxwidth" :leftdot="false" />
                        </div>
                        <div>
                            <Skeleton class="whiteboxwidth" height="2.5rem" v-if="loading" />
                            <WhiteBox v-else :boxtext="leftboxtext.tostr" :StoreId="leftboxtext.tostoreid"
                                :storestatus="leftboxtext.tostatus" :Badge="leftboxtext.tocount !== '' ? true : false"
                                :count="leftboxtext.tocount" class="whiteboxwidth" :rightdot="false" />
                        </div>
                    </div>
                    <div class="outline-box">
                        <div class="rightarrow">
                            <i class="pi pi-caret-right" style="color: white ; font-size: 0.5rem;"></i>
                        </div>
                        <div class="leftarrow">
                            <i class="pi pi-caret-left" style="color: #e1e1e1 ; font-size: 0.5rem;"></i>
                        </div>
                    </div>

                </b-col>
            </b-row>
        </b-container>
    </section>
</template>
<script lang="ts">
import { defineComponent, ref } from "vue";
import WhiteBox from './ChartWhiteBox.vue'
export default defineComponent({
    props: {
        leftboxtext: {
            type: Object,
            default: {}
        },
        loading: {
            type: Boolean,
            default: false
        },
    },
    components: {
        WhiteBox
    },

    setup() {
        return {};
    },
});
</script>
<style lang="scss">
.outline-box {
    width: 48%;
    height: 75px;
    border: 1px solid #707070;
    margin-left: auto;
    margin-right: auto;
    position: absolute;
    right: 25.95% !important;
    top: 49% !important;
    z-index: -1;
}



.width70 {
    width: 70% !important;
    margin: 0 auto !important;
    position: relative;
    z-index: 2;
    padding: 9% 0;

}

.rightarrow {
    position: relative;

    .pi {
        position: absolute;
        left: 50%;
        top: -4px;
    }
}

.leftarrow {
    position: relative;

    .pi {
        position: absolute;
        left: 50%;
        top: -1px;
    }

}

.whiteboxwidth {
    width: 144px !important;
}

@media only screen and (min-width: 1025px) {
    .outline-box {
        top: 40%;
        width: 48.8%;
    }

    .leftarrow {
        .pi {
            top: 70px !important;
        }
    }

    .width70 {
        padding: 2% 0;
    }

}

@media only screen and (max-width: 1024px) {
    .outline-box {
        top: 37%;
        right: 26.25% !important;
        width: 48.5%;
    }

    .leftarrow {
        top: 70px !important;

    }

    .width70 {
        padding: 2% 0;
    }
}

@media only screen and (max-width: 992px) {
    .outline-box {
        top: 48% !important;
        right: 27% !important;
        width: 47.75%;
    }

    .leftarrow {
        top: 70px !important;
    }

}

@media only screen and (max-width: 767px) {
    .outline-box {
        top: 36%;
    }

    .leftarrow {
        top: 127% !important;
    }

    .rightarrow {
        top: 37% !important;
        right: 48.25%;
    }

}
</style>
